export enum ResponseErrorCode {
  AUTO_FUNNEL_PAYMENT_NO_POSTAL_CODE = 200018,
  PAYPAL_NO_BUTTONS = 12010,
}
